import { Injectable } from '@angular/core';
import { News } from '../models/news';
import { DatabaseService } from './base/database.service';
import { UserService } from './user.service';
import { ClaimsService } from './claims.service';

@Injectable({
  providedIn: 'root',
})
export class NewsService extends DatabaseService<News> {
  public teste: any;

  constructor(private us: UserService, private cs: ClaimsService) {
    super('cp_news');
  }

  async getNews() {
    const ret = await this.getAll(3, 0);

    return ret;
  }

  async getNewsByNewest(
    config: {
      limit?: number;
      page?: number;
      order?: 'desc' | 'asc';
      orderBy?: string;
    } = {}
  ) {
    const newsOptionsQuery = {
      limit: 10,
      page: 0,
      order: 'desc',
      orderBy: 'created_at',
      ...config,
    };

    const query = this.supabase
      .from(this.table)
      .select()
      .order(newsOptionsQuery.orderBy, {
        ascending: newsOptionsQuery.order === 'asc',
      });
    if (newsOptionsQuery.limit) query.limit(newsOptionsQuery.limit);
    if (newsOptionsQuery.page) {
      const { from, to } = this._getPagination(
        newsOptionsQuery.page,
        newsOptionsQuery.limit
      );
      query.range(from, to);
    }

    const { data, error } = await query;

    return (data as News[]) || [];
  }
  async getNewsByRelatedCase(
    idCase: string,
    limit: number = 3
  ): Promise<News[]> {
    const q = this.supabase
      .from(this.table)
      .select()
      .eq('case_id', idCase)
      .order('created_at', { ascending: false });
    if (limit) q.limit(limit);

    const { data, error } = await q;
    if (error) throw new Error(error.message);

    return data;
  }

  async getByHighlightPriority(limit: number = 3) {
    const q = this.supabase
      .from(this.table)
      .select()
      .order('metadata->highlight_priority', { ascending: false });
    if (limit) q.limit(limit);

    const { data, error } = await q;
    if (error) throw new Error(error.message);

    return data;
  }

  async getByRelevance(limit: number = 3) {
    const cu = await this.us.getCurrentUser();
    if (!cu || !cu.id) {
      throw new Error('User not loaded');
    }
    const claims = await this.cs.getClaimWithCaseForUserId(cu.id, 10, 0);
    const cases = claims.map((cl) => cl.case_id);

    const q = this.supabase
      .from(this.table)
      .select()
      .order('metadata->highlight_priority', { ascending: false })
      .in('case_id', cases)
      .limit(limit);

    const { data, error } = await q;
    if (error) throw new Error(error.message);

    try {
       if (data.length < limit) {
         const addNewsAmt = limit - data.length;
         const q2 = this.supabase
           .from(this.table)
           .select()
           .order('metadata->highlight_priority', { ascending: false })
           .not('case_id', 'in', cases)
           .limit(addNewsAmt);
         let nv = (await q2).data;
         if (!nv) nv = [];
         nv.push(...data);
         return nv;
       } else {
         return data;
       }
      
    } catch (error) {
     return data; 
    } finally {
      return data;
    }
   

  }
}
